var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantomeDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 963.98 872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#ffd93b;}.cls-3{opacity:0.46;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fantome 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1437.45,1377H520.25c-17.52,0-28.53-19.42-19.88-35.08l455.09-824a22.56,22.56,0,0,1,39.69-.14l462.1,824C1466,1357.45,1455,1377,1437.45,1377Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1346.57,1324.5H603.13c-14.2,0-23.13-15.74-16.12-28.43L955.89,628.14a18.29,18.29,0,0,1,32.17-.11L1362.63,1296C1369.74,1308.65,1360.83,1324.5,1346.57,1324.5Z",
    transform: "translate(-496.86 -505.5)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_10",
    "data-name": "Calque 10"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 478.14,
    cy: 737.4,
    r: 40.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975,786S910.2,776.64,925.27,901s28.54,236.92,28.54,236.92c3.86,27,37.56,29.32,42.38,0,0,0,13.47-112.59,28.54-236.92S975,786,975,786Z",
    transform: "translate(-496.86 -505.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantomeDanger);
export default __webpack_public_path__ + "static/media/fantome_danger.75b7e331efeb9ceb66836e0568ec5c10.svg";
export { ForwardRef as ReactComponent };